import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-floating, floating-window" maskId="round-filled-radius-0-stroke-1.5-IconSidebarFloating"><path fillRule="evenodd" clipRule="evenodd" d="M21.25 4C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75C2 4.33579 2.33579 4 2.75 4H21.25ZM14.5 10.5V16.5H18.5V10.5H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
